<template>
	<div>
		<flCabecalhoForm
			class="print-titulo-form-20"
			:texto="_traducao('global', 'tempoDeVoo')"
		/>
		<AlertInfo>
			<span v-if="fusoHorario != 'UTC'">
				{{ _traducao('global', 'preenchimentoMotorHorario') }}
			</span>
			<span v-else> {{ _traducao('global', 'preenchimentoUTC') }}. </span>
		</AlertInfo>
		<div class="row">
			<div
				class="col-xs-6 col-md-2 form-group"
				:class="{'has-error': erroTempoVoo.tempo_voo_piloto != ''}"
			>
				<input-time
					name="dtOrdemInicio"
					:label="labelTempoAcionamentoCorte"
					v-model="tempoVooPiloto"
					:disabled="true"
				/>
				<p class="help-block" v-if="erroTempoVoo.tempo_voo_piloto != ''">
					{{ erroTempoVoo.tempo_voo_piloto }}
				</p>
				<label v-show="formTempoVoo.tempo_voo_piloto != ''">
					{{ _traducao('global', 'tempo') }}:
					{{ formTempoVoo.tempo_voo_piloto }}
				</label>
			</div>
			<div
				class="col-xs-6 col-md-2 form-group"
				:class="{'has-error': erroTempoVoo.tempo_voo_motor != ''}"
			>
				<input-time
					name="dtOrdemInicio"
					:label="_traducao('global', 'totalDecolagemPouso')"
					v-model="tempoVooMotor"
					:disabled="true"
				/>
				<p class="help-block" v-if="erroTempoVoo.tempo_voo_motor != ''">
					{{ erroTempoVoo.tempo_voo_motor }}
				</p>
				<label v-show="form.tempo_voo_motor != ''"
					>{{ _traducao('global', 'tempo') }}: {{ form.tempo_voo_motor }}</label
				>
			</div>
			<div
				class="col-xs-6 col-md-2 form-group"
				style="text-overflow: ellipsis"
				:class="{'has-error': erroTempoVoo.vfr_diurno != ''}"
			>
				<input-time
					:label="'* ' + _traducao('global', 'diurno')"
					v-model="formTempoVoo.hora_vfr_diurno"
				/>
				<p class="help-block" v-if="erroTempoVoo.vfr_diurno != ''">
					{{ erroTempoVoo.vfr_diurno }}
				</p>
				<label v-show="formTempoVoo.vfr_diurno != ''"
					>{{ _traducao('global', 'decimo') }}:
					{{ formTempoVoo.vfr_diurno }}</label
				>
			</div>
			<div
				class="col-xs-6 col-md-2 form-group"
				style="text-overflow: ellipsis"
				:class="{'has-error': erroTempoVoo.vfr_noturno != ''}"
			>
				<input-time
					:label="'* ' + _traducao('global', 'noturno')"
					v-model="formTempoVoo.hora_vfr_noturno"
				/>
				<p class="help-block" v-if="erroTempoVoo.vfr_noturno != ''">
					{{ erroTempoVoo.vfr_noturno }}
				</p>
				<label v-show="formTempoVoo.vfr_noturno != ''"
					>{{ _traducao('global', 'decimo') }}:
					{{ formTempoVoo.vfr_noturno }}</label
				>
			</div>
			<div
				v-if="validaVfr == true"
				class="col-xs-6 col-md-2 form-group"
				style="text-overflow: ellipsis"
				:class="{'has-error': erroTempoVoo.ifr != ''}"
			>
				<input-time
					label="* IFR Real"
					v-model="formTempoVoo.hora_ifr"
					:disabled="aeronave.tipo_ifr == '1'"
				/>
				<p class="help-block" v-if="erroTempoVoo.ifr != ''">
					{{ erroTempoVoo.ifr }}
				</p>
				<label v-show="formTempoVoo.ifr != ''"
					>{{ _traducao('global', 'decimo') }}: {{ formTempoVoo.ifr }}</label
				>
			</div>
			<div
				v-if="validaVfr == true"
				class="col-xs-6 col-md-2 form-group"
				style="text-overflow: ellipsis"
				:class="{'has-error': erroTempoVoo.vfr != ''}"
			>
				<input-time label="* VFR" v-model="formTempoVoo.hora_vfr" />
				<p class="help-block" v-if="erroTempoVoo.vfr != ''">
					{{ erroTempoVoo.vfr }}
				</p>
				<label v-show="formTempoVoo.vfr != ''"
					>{{ _traducao('global', 'decimo') }}: {{ formTempoVoo.vfr }}</label
				>
			</div>
			<div
				v-if="validaVfr == false"
				class="col-xs-6 col-md-2 form-group"
				style="text-overflow: ellipsis"
				:class="{'has-error': erroTempoVoo.ifr != ''}"
			>
				<input-time
					label="* IFR"
					v-model="formTempoVoo.hora_ifr"
					:disabled="aeronave.tipo_ifr == '1'"
				/>
				<p class="help-block" v-if="erroTempoVoo.ifr != ''">
					{{ erroTempoVoo.ifr }}
				</p>
				<label v-show="formTempoVoo.ifr != ''"
					>{{ _traducao('global', 'decimo') }}: {{ formTempoVoo.ifr }}</label
				>
			</div>
			<div
				class="col-xs-12 col-md-2 form-group"
				:class="{'has-error': erroTempoVoo.navegacao != ''}"
				v-if="validaVfr == false"
			>
				<input-time
					:label="_traducao('global', 'navegacao')"
					v-model="formTempoVoo.hora_navegacao"
				/>
				<label v-show="formTempoVoo.navegacao != ''"
					>{{ _traducao('global', 'decimo') }}:
					{{ formTempoVoo.navegacao }}</label
				>
				<p class="help-block" v-if="erroTempoVoo.navegacao != ''">
					{{ erroTempoVoo.navegacao }}
				</p>
			</div>
		</div>
		<div class="row">
			<div
				class="col-xs-6 col-md-2 form-group"
				:class="{'has-error': erroTempoVoo.ifr_simulado != ''}"
			>
				<input-time
					:label="'* ' + _traducao('global', 'ifrSimulado')"
					v-model="formTempoVoo.hora_ifr_simulado"
					:disabled="aeronave.tipo_ifr == '0'"
				/>
				<label v-show="formTempoVoo.ifr_simulado != ''">
					{{ _traducao('global', 'decimo') }}
					{{ formTempoVoo.ifr_simulado }}
				</label>
				<p class="help-block" v-if="erroTempoVoo.ifr_simulado != ''">
					{{ erroTempoVoo.ifr_simulado }}
				</p>
			</div>

			<div
				v-if="validaVfr == true"
				class="col-xs-6 col-md-2 form-group"
				:class="{'has-error': erroTempoVoo.navegacao != ''}"
			>
				<input-time
					:label="_traducao('global', 'navegacao')"
					v-model="formTempoVoo.hora_navegacao"
				/>
				<label v-show="formTempoVoo.navegacao != ''"
					>{{ _traducao('global', 'decimo') }}:
					{{ formTempoVoo.navegacao }}</label
				>
				<p class="help-block" v-if="erroTempoVoo.navegacao != ''">
					{{ erroTempoVoo.navegacao }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import $carrega from '../mixins/carrega.js'
export default {
	name: 'ComponenteTempoVoo',
	mixins: [$carrega],
	props: {
		form: {
			default() {
				return {}
			},
			type: Object,
			required: true
		},
		erro: {
			default() {
				return {}
			},
			type: Object,
			required: true
		},
		aeronave: {
			default() {
				return {}
			},
			type: Object,
			required: true
		},
		fusoHorario: {
			type: String,
			default: 'local',
			required: false
		},
		labelTempoAcionamentoCorte: {
			type: String,
			default: '',
			required: true
		},
		validaVfr: {
			type: Boolean,
			default: true,
			required: true
		},
		preencher: {
			type: Boolean,
			default: true,
			required: true
		},
		editar: {
			type: Boolean,
			default: false,
			required: true
		}
	},
	data() {
		return {
			formTempoVoo: {},
			erroTempoVoo: {}
		}
	},
	methods: {
		async validadorFormTempoVoo() {
			if (await this.validarComponenteTempoVoo()) {
				this.$emit('tempo-voo-valido', this.formTempoVoo)
			} else {
				this.$emit('tempo-voo-invalido', this.erroTempoVoo)
			}
		},

		async validarComponenteTempoVoo() {
			var passou = true
			var preenchaPeloMenosUmCampo = this._traducao(
				'global',
				'preenchaPeloMenosUmCampo'
			)

			if (this.formTempoVoo.hora_ifr != '' || this.formTempoVoo.hora_vfr != '' || this.formTempoVoo.hora_ifr_simulado) {
				this.erroTempoVoo.ifr = ''
				this.erroTempoVoo.vfr = ''
				this.erroTempoVoo.ifr_simulado = ''
			} else {
				this.erroTempoVoo.ifr = preenchaPeloMenosUmCampo
				this.erroTempoVoo.vfr = preenchaPeloMenosUmCampo
				passou = false
			}

			return passou
		},

		formatarComDoisDigitos(valor) {
			return valor < 10 ? `0${valor}` : valor.toString()
		},

		calcularTempoVoo(inicio, fim) {
			if (inicio == '' || fim == '') {
				return ''
			}
			if (inicio == fim) {
				return '00:00'
			}
			const inicioMoment = this._criarMomentHHmm(inicio)
			const fimMoment = this._criarMomentHHmm(fim)

			const duracao = moment.duration(fimMoment.diff(inicioMoment))

			const horasTotais = this.formatarComDoisDigitos(
				duracao.hours() + duracao.days() * 24
			)
			const minutosTotais = this.formatarComDoisDigitos(duracao.minutes())

			return `${horasTotais}:${minutosTotais}`
		},
		calcularTempoDiurnoNoturno(periodo) {
			const horaVFR =
				periodo === 'diurno'
					? this.formTempoVoo.hora_vfr_diurno
					: this.formTempoVoo.hora_vfr_noturno

			const horasFormatada = this.calcularDiferencaTempoVoo(this.tempoVoo, horaVFR)
			this.atualizarHorasVFROpposite(periodo, horasFormatada)
		},

		calcularDiferencaTempoVoo(tempo1, tempo2) {
			let diff = moment(tempo1, 'HH:mm').diff(
				moment(tempo2, 'HH:mm'),
				'minutes'
			)

			let hours = Math.floor(diff / 60)
			let minutes = diff % 60

			hours = this.formatarComDoisDigitos(hours),
			minutes = this.formatarComDoisDigitos(minutes)

			return `${hours}:${minutes}`
		},

		atualizarHorasVFROpposite(periodoAtual, horasFormatada) {
			const horarioZerado = '00:00'

			switch (periodoAtual) {
			case 'diurno':
				this.formTempoVoo.hora_vfr_noturno = horasFormatada
				this.formTempoVoo.vfr_noturno = horarioZerado

				if (this.formTempoVoo.hora_vfr_noturno !== horarioZerado) {
					this.formTempoVoo.vfr_noturno = this._horasParaDecimal(this.formTempoVoo.hora_vfr_noturno).toFixed(1)
				}
				break

			case 'noturno':
				this.formTempoVoo.hora_vfr_diurno = horasFormatada
				this.formTempoVoo.vfr_diurno = horarioZerado

				if (this.formTempoVoo.hora_vfr_diurno !== horarioZerado) {
					this.formTempoVoo.vfr_diurno = this._horasParaDecimal(this.formTempoVoo.hora_vfr_diurno).toFixed(1)
				}
				break

			default:
				this.formTempoVoo.vfr_diurno = horarioZerado
				this.formTempoVoo.vfr_noturno = horarioZerado
				break
			}
		},
		calcularHorasTipoVooIfr() {
			const horarioZerado = '00:00'

			const decimalTempoInstrumento = this._horasParaDecimal(this.formTempoVoo.hora_ifr)
			const decimalTempoVoo = this._horasParaDecimal(this.tempoVoo)

			if(Number(decimalTempoInstrumento) >= Number(decimalTempoVoo)){

				this.formTempoVoo.hora_ifr = this.tempoVoo
				this.formTempoVoo.hora_vfr = horarioZerado
				this.formTempoVoo.hora_ifr_simulado = horarioZerado
			}

			switch (this.aeronave.tipo_ifr) {
			case '0':
				this.formTempoVoo.hora_vfr = this.calcularDiferencaTempoVoo(
					this.tempoVoo,
					this.formTempoVoo.hora_ifr
				)
				break
			case '1':
				this.formTempoVoo.hora_ifr = this.formTempoVoo.hora_ifr
				this.formTempoVoo.hora_vfr = this.formTempoVoo.hora_vfr
				this.formTempoVoo.hora_ifr_simulado = this.formTempoVoo.hora_ifr_simulado
				break
			case '2':
				if (this.formTempoVoo.hora_ifr != '' && this.formTempoVoo.hora_vfr != '') {
					this.formTempoVoo.hora_ifr_simulado = this.geraTempoInstrumentos(
						this.formTempoVoo.hora_ifr,
						this.tempoVoo,
						this.formTempoVoo.hora_vfr
					)

				} else if (this.form.hora_ifr_simulado != '') {
					this.form.hora_vfr = this.geraTempoInstrumentos(
						this.form.hora_ifr,
						this.tempoVoo,
						this.form.hora_ifr_simulado
					)
				}

				break

			default:
				this.formTempoVoo.hora_vfr = horarioZerado
				this.formTempoVoo.hora_ifr_simulado = horarioZerado
				break
			}
			this.formTempoVoo.ifr = '0.0'
			this.erroTempoVoo.ifr = ''

			if (this.formTempoVoo.hora_ifr != '0.0') {
				this.formTempoVoo.ifr = this._horasParaDecimal(this.formTempoVoo.hora_ifr).toFixed(1)

				if (this._validaTempoMenor(this.tempoVoo, this.formTempoVoo.hora_ifr)) {
					this.erroTempoVoo.ifr = this._traducao(
						'global',
						'valorMaiorQueTempoPiloto'
					)
				}
			}
		},
		calcularHorasTipoVooVfr() {
			const horarioZerado = '00:00'
			const decimalTempoInstrumento = this._horasParaDecimal(this.formTempoVoo.hora_vfr)
			const decimalTempoVoo = this._horasParaDecimal(this.tempoVoo)

			if(Number(decimalTempoInstrumento) >= Number(decimalTempoVoo)){

				this.formTempoVoo.hora_ifr = horarioZerado
				this.formTempoVoo.hora_vfr = this.tempoVoo
				this.formTempoVoo.hora_ifr_simulado = horarioZerado
			}

			switch (this.aeronave.tipo_ifr) {
			case '0':
				this.formTempoVoo.hora_ifr = this.calcularDiferencaTempoVoo(
					this.tempoVoo,
					this.formTempoVoo.hora_vfr
				)
				break
			case '1':
				this.formTempoVoo.hora_ifr_simulado = this.calcularDiferencaTempoVoo(
					this.tempoVoo,
					this.formTempoVoo.hora_vfr
				)
				break
			case '2':
				if (this.formTempoVoo.hora_ifr != '' && this.formTempoVoo.hora_vfr != '') {
					this.formTempoVoo.hora_ifr_simulado = this.geraTempoInstrumentos(
						this.formTempoVoo.hora_vfr,
						this.tempoVoo,
						this.formTempoVoo.hora_ifr
					)
				} else if (this.form.hora_ifr_simulado != '') {
					this.form.hora_vfr = this.geraTempoInstrumentos(
						this.form.hora_ifr,
						this.tempoVoo,
						this.form.hora_ifr_simulado
					)
				}
				break

			default:
				this.formTempoVoo.hora_ifr = horarioZerado
				this.formTempoVoo.hora_vfr = horarioZerado
				this.formTempoVoo.hora_ifr_simulado = horarioZerado
				break
			}

			this.formTempoVoo.vfr = '0.0'
			this.erroTempoVoo.vfr = ''


			if (this.formTempoVoo.hora_vfr != '0.0') {
				this.formTempoVoo.vfr = this._horasParaDecimal(this.formTempoVoo.hora_vfr).toFixed(1)

				if (this._validaTempoMenor(this.tempoVoo, this.formTempoVoo.hora_vfr)) {
					this.erroTempoVoo.vfr = this._traducao(
						'global',
						'valorMaiorQueTempoPiloto'
					)
				}
			}
		},

		calcularHorasTipoVooIfrSimulado() {
			const horarioZerado = '00:00'

			const decimalTempoInstrumento = this._horasParaDecimal(this.formTempoVoo.hora_ifr_simulado)
			const decimalTempoVoo = this._horasParaDecimal(this.tempoVoo)
			if(Number(decimalTempoInstrumento) >= Number(decimalTempoVoo)){

				this.formTempoVoo.hora_ifr = horarioZerado
				this.formTempoVoo.hora_vfr = horarioZerado
				this.formTempoVoo.hora_ifr_simulado = this.tempoVoo
			}
			switch (this.aeronave.tipo_ifr) {
			case '0':
				this.formTempoVoo.hora_ifr = this.formTempoVoo.hora_ifr
				this.formTempoVoo.hora_vfr = this.formTempoVoo.hora_vfr
				this.formTempoVoo.hora_ifr_simulado = this.formTempoVoo.hora_ifr_simulado
				break
			case '1':
				this.formTempoVoo.hora_vfr = this.calcularDiferencaTempoVoo(
					this.tempoVoo,
					this.formTempoVoo.hora_ifr_simulado
				)
				break
			case '2':

				if (this.formTempoVoo.hora_ifr_simulado != '' && this.formTempoVoo.hora_vfr != '') {
					this.formTempoVoo.hora_ifr = this.geraTempoInstrumentos(
						this.formTempoVoo.hora_ifr_simulado,
						this.tempoVoo,
						this.formTempoVoo.hora_vfr
					)
				} else if (this.formTempoVoo.hora_ifr_simulado != '' && this.form.hora_ifr != '') {
					this.form.hora_vfr = this.geraTempoInstrumentos(
						this.form.hora_ifr_simulado,
						this.tempoVoo,
						this.form.hora_ifr
					)
				}
				break

			default:
				this.formTempoVoo.hora_ifr_simulado = horarioZerado
				this.formTempoVoo.hora_vfr = horarioZerado
				break
			}

			this.formTempoVoo.ifr_simulado = 0.0
			this.erroTempoVoo.ifr_simulado = ''
			
			if (this.formTempoVoo.hora_ifr_simulado != '0.0') {
				this.formTempoVoo.ifr_simulado = this._horasParaDecimal(this.formTempoVoo.hora_ifr_simulado).toFixed(1)

				if (Number(decimalTempoInstrumento) > Number(decimalTempoVoo)) {
					this.erroTempoVoo.ifr_simulado = this._traducao(
						'global',
						'valorMaiorQueTempoPiloto'
					)
				}
			}
		},

		geraTempoInstrumentos(tempoAlterado, tempoVoo, tempoParaCalculo) {
			const duracaoTempoAlterado = moment.duration(tempoAlterado, 'HH:mm')
			const duracaoTempoVoo = moment.duration(tempoVoo, 'HH:mm')
			const duracaoTempoParaCalculo = moment.duration(tempoParaCalculo, 'HH:mm')

			let somaTempos = duracaoTempoParaCalculo.add(duracaoTempoAlterado)

			if (somaTempos.asMilliseconds() === duracaoTempoVoo.asMilliseconds()) {
				return '00:00'
			} else if (
				somaTempos.asMilliseconds() <= duracaoTempoVoo.asMilliseconds()
			) {
				const valorTempoRetornar = duracaoTempoVoo.subtract(somaTempos)
				let hours = valorTempoRetornar.hours()
				let minutes = valorTempoRetornar.minutes()

				hours = this.formatarComDoisDigitos(hours)
				minutes = this.formatarComDoisDigitos(minutes)
				return hours + ':' + minutes
			} else {
				return '00:00'
			}
		},
		validaTempoHorasNavegacao(){
			this.formTempoVoo.navegacao = '0.0'
			this.erroTempoVoo.navegacao = ''

			if (this.formTempoVoo.hora_navegacao != '00:00') {
				this.formTempoVoo.navegacao = this._horasParaDecimal(this.formTempoVoo.hora_navegacao).toFixed(1)

				if (this._validaTempoMenor(this.tempoVoo, this.formTempoVoo.hora_navegacao)) {
					this.erroTempoVoo.navegacao = this._traducao(
						'global',
						'valorMaiorQueTempoPiloto'
					)
				}
			}
		}
	},
	computed: {
		tempoVooPiloto() {
			return this.calcularTempoVoo(this.form.acionamento, this.form.corte)
		},
		tempoVooMotor() {
			return this.calcularTempoVoo(this.form.decolagem, this.form.pouso)
		},
		calculaDecolagemAoPouso() {
			return this.aeronave.tempo_calculo_ifr_vfr === 'DECOLAGEM AO POUSO';
		},
		tempoVoo() {
			return this.calculaDecolagemAoPouso ? this.tempoVooMotor : this.tempoVooPiloto;
		}
	},
	watch: {
		'form': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.formTempoVoo = this.form
				}
			}
		},
		'erro': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.erroTempoVoo = this.erro
				}
			}
		},

		'formTempoVoo.hora_vfr_diurno': {
			immediate: true,
			handler(val, oldVal) {
				const valorFoiAlterado = val && val !== oldVal
				const acaoRequerida = this.preencher || this.editar

				if (valorFoiAlterado && acaoRequerida) {
					this.calcularTempoDiurnoNoturno('diurno')
				}
			}
		},
		'formTempoVoo.hora_vfr_noturno': {
			immediate: true,
			handler(val, oldVal) {
				const valorFoiAlterado = val && val !== oldVal
				const acaoRequerida = this.preencher || this.editar

				if (valorFoiAlterado && acaoRequerida) {
					this.calcularTempoDiurnoNoturno('noturno')
				}
			}
		},
		'formTempoVoo.hora_ifr': {
			immediate: true,
			handler(val, oldVal) {
				const valorFoiAlterado = val && val !== oldVal
				const acaoRequerida = this.preencher || this.editar

				if (valorFoiAlterado && acaoRequerida) {
					this.calcularHorasTipoVooIfr()
				}
			}
		},
		'formTempoVoo.hora_vfr': {
			immediate: true,
			handler(val, oldVal) {
				const valorFoiAlterado = val && val !== oldVal
				const acaoRequerida = this.preencher || this.editar

				if (valorFoiAlterado && acaoRequerida) {
					this.calcularHorasTipoVooVfr()
				}
			}
		},
		'formTempoVoo.hora_ifr_simulado': {
			immediate: true,
			handler(val, oldVal) {
				const valorFoiAlterado = val && val !== oldVal
				const acaoRequerida = this.preencher || this.editar

				if (valorFoiAlterado && acaoRequerida) {
					this.calcularHorasTipoVooIfrSimulado()
				}
			}
		},
		'formTempoVoo.hora_navegacao' : {
			immediate: true,
			handler(val, oldVal) {
				const valorFoiAlterado = val && val !== oldVal
				const acaoRequerida = this.preencher || this.editar

				if (valorFoiAlterado && acaoRequerida) {
					this.validaTempoHorasNavegacao()
				}
			}
		},
	}
}
</script>